
import { atom } from "jotai";
import { documentFilterGroups } from "./predicate";
import { DocumentFilterAtom } from "./type";

const documentFilters: DocumentFilterAtom = {
  filterGroup: documentFilterGroups,
  filterValues: {
    entity_types: ["CUSTOMER", "INVOICE"],
  },
  activeFilterKeys: ['types', "date_range", "from_date", "to_date"],
  sorting: {
    sort_col: "CREATED_DATE",
    order: 'DESC',
  },
};

export const documentFiltersAtom = atom(documentFilters);
